<template>
  <div :class="alertClass" v-if="isShow">
    <div class="alert-cont" v-if="type === 1">{{ text }}</div>
    <div class="alert-cont2" v-if="type === 2">
      <div class="alert-msg">{{ text }}</div>
      <div class="alert-btn" @click="closeAlert">{{ btnTxt }}</div>
    </div>
    <div class="alert-cont3" v-if="type === 3">
      <div class="alert-msg">{{ text }}</div>
      <div class="alert-btn clearfix">
        <p class="sure btn fl" @click="sureAlert">{{ btnTxt }}</p>
        <p class="cancel btn fl" @click="closeAlert">取消</p>
      </div>
    </div>
  </div>
  <template v-else></template>
</template>

<script>
import { ref } from 'vue'
export default {
  props: {
    type: {
      type: Number,
      default: 1
    },
    sure: {
      type: Function
    },
    close: {
      type: Function
    },
    text: {
      type: String,
      default: ''
    },
    btnTxt: {
      type: String,
      default: '确定'
    }
  },
  computed: {
    alertClass() {
      return 'alert-container' + (this.type == 1 ? '' : ' bg0')
    }
  },
  setup(props) {
    let isShow = ref(true)
    function closeAlert() {
      hide()
      props.close && props.close()
    }
    const sureAlert = () => {
      hide()
      props.sure && props.sure()
    }
    function hide() {
      isShow.value = false
    }
    return {
      isShow,
      hide,
      closeAlert,
      sureAlert
    }
  }
}
</script>
<style scoped lang="less">
.alert-container .alert-btn {
  height: 1.3rem;
  line-height: 1.3rem;
}
.alert-container .alert-msg {
  border-bottom: 0.03rem solid #dadada;
  padding: 0.5rem;
  margin: 0 0.2rem;
  word-break: break-all;
}
.alert-container.bg0 {
  background: rgba(0, 0, 0, 0.5) !important;
}
.alert-container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0);
  z-index: 99999;
}
.alert-container .alert-cont {
  word-wrap: break-word;
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 80%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 0.3rem 0.5rem;
  font-size: 0.4rem;
  border-radius: 0.3rem;
  text-align: center;
  min-width: 4rem;
  animation: popCont 0.2s linear 0ms 1 normal forwards;
}
.alert-container .alert-cont2,
.alert-container .alert-cont3 {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  background: #fff;
  color: #666;
  font-size: 0.4rem;
  border-radius: 0.3rem;
  text-align: center;
  line-height: 0.5rem;
  animation: popCont 0.2s linear 0ms 1 normal forwards;
}
.alert-container .alert-cont3 .alert-msg {
  min-height: 1rem;
}
.alert-container .alert-cont3 .alert-btn .btn {
  width: 50%;
}
.alert-container .alert-cont3 .alert-btn .cancel {
  border-left: 0.03rem solid #dadada;
  box-sizing: border-box;
}
.pop-cont {
  border-radius: 10px;
  .codeErr {
    width: 250px;
    padding: 14px;
    box-sizing: border-box;
    img {
      display: block;
      width: 150px;
      height: 128px;
      margin: 10px auto 10px;
    }
    .result-content {
      width: 170px;
      margin: 0 auto 10px;
      font-size: 14px;
    }
    .btn-result {
      background: linear-gradient(135deg, #528aff, #1d65ff);
      width: 150px;
      height: 34px;
      line-height: 34px;
      border-radius: 25px;
      text-align: center;
      color: #fff;
      margin: 0 auto;
    }
  }
}
</style>
